module.exports = __webpack_public_path__ + "img/renta4.61371845.png";